import { FC } from 'react'
// import { useDispatch } from 'react-redux'
import styles from 'styles/components/template.module.scss'
import SubmitButton from 'components/Button/SubmitButton'
import { useNavigate } from 'react-router-dom'
import Logo from 'components/Icons/Logo'
import Accept from 'images/accept.png'
// import { RootState } from 'reducks/reducers'
// import { AppDispatch } from 'index'

const ResetPasswordCompleteTemplate: FC = () => {
  // const dispatch = useDispatch<any>()
  const navigate = useNavigate()
  // const { roles } = useSelector((state: RootState) => state.staffSlice)

  const handleSubmit = async () => {
    navigate('/login')
  }

  return (
    <div className={styles.login_container}>
      <div className={styles.login_logo}>
        <Logo width={368} />
      </div>
      <div className={styles.login_form_container}>
        <div className={styles.login_description}>
          <div className={styles.login_description_title}>
            パスワードが再設定されました
          </div>
        </div>
        <img
          className={styles.login_description_img}
          src={Accept}
          alt="accept"
        />
      </div>
      <div className={styles.login_button_container} style={{ marginTop: 40 }}>
        <SubmitButton
          label="ログインページへ"
          color="orange"
          size="large"
          icon="none"
          onClick={() => handleSubmit()}
        />
      </div>
    </div>
  )
}

export default ResetPasswordCompleteTemplate
